import { render, staticRenderFns } from "./BmvSelect.vue?vue&type=template&id=4938884c&scoped=true"
import script from "./BmvSelect.vue?vue&type=script&lang=js"
export * from "./BmvSelect.vue?vue&type=script&lang=js"
import style0 from "./BmvSelect.vue?vue&type=style&index=0&id=4938884c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4938884c",
  null
  
)

export default component.exports